var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBluetooth = function SvgIconBluetooth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.85 2.2a1 1 0 0 0-1.6.8v7l-4.4-3.3a1 1 0 1 0-1.2 1.6L9.583 12 4.65 15.7a1 1 0 0 0 1.2 1.6l4.4-3.3v7a1 1 0 0 0 1.6.8l6-4.5a1 1 0 0 0 0-1.6L12.917 12l4.933-3.7a1 1 0 0 0 0-1.6zm3.733 5.3L12.25 10V5zm0 9L12.25 19v-5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconBluetooth;